let MobileNav = () => {
  /* Elements */
  let elems = {
    hamburgerBtn: document.querySelector(".menu-bar .mobile-hamburger-btn"),
    backBtn: document.querySelector(".mobile-nav-menu .back-btn"),
    closeBtn: document.querySelector(".mobile-nav-menu .close-btn"),
    mobileMenu: document.querySelector(".mobile-nav-menu"),
    body: document.querySelector(".mobile-nav-menu .body"),
    pages: Array.from(document.querySelectorAll(".mobile-nav-menu .body .body-page")),
  };

  /* Timeouts */
  let timers = {
    show: undefined,
    hide: undefined,
  };

  /* Settings */
  let durations = {
    show: 300,
    hide: 300,
  };

  /* Functions */
  function Init() {
    elems.hamburgerBtn.addEventListener("click", Show);
    elems.backBtn.addEventListener("click", BackToHome);
    elems.closeBtn.addEventListener("click", Hide);

    // Nested Links
    elems.pages.forEach(page => {
      let nestedLinks = Array.from(page.querySelectorAll(".nested-link > a"));
      let categoryLinks = Array.from(page.querySelectorAll(".category-link > a"));
      let subcategoryLinks = Array.from(page.querySelectorAll(".sub-category-link > a"));

      nestedLinks.forEach(link => {
        link.addEventListener("click", e => {
          e.preventDefault();
          ShowPage(e.currentTarget.getAttribute("data-page"));
        });
      });

      categoryLinks.forEach(link => {
        link.addEventListener("click", CategoryClickHandler);
      });

      subcategoryLinks.forEach(link => {
        link.addEventListener("click", SubcategoryClickHandler);
      });
    });
  }

  /* - Visibility */
  function Show() {
    if (timers.hide) {
      clearTimeout(timers.hide);
    }

    Global.Overlay.Background.freezeScreen();

    elems.mobileMenu.classList.remove("sk-hidden");
    timers.show = setTimeout(ShowTimeoutCallback, durations.show);
  }

  function ShowTimeoutCallback() {
    // Get height and set mobile nav height to page height
    let height = elems.pages.find(page => page.classList.contains("active")).clientHeight;
    elems.body.style.height = `${height}px`;

    elems.mobileMenu.classList.add("active");
  }

  function Hide() {
    if (timers.show) {
      clearTimeout(timers.show);
    }

    elems.mobileMenu.classList.remove("active");
    timers.hide = setTimeout(HideTimeoutCallback, durations.hide);
  }

  function HideTimeoutCallback() {
    elems.mobileMenu.classList.add("sk-hidden");
    Global.Overlay.Background.unfreezeScreen();
  }

  /* - Page */
  function ShowPage(pageName = "") {
    if (pageName === "") return;

    if (pageName !== "home") {
      elems.backBtn.classList.remove("sk-hidden");
    } else {
      elems.backBtn.classList.add("sk-hidden");
    }

    // Get target page
    let targetPage = elems.pages.find(page => page.getAttribute("data-page") === pageName);
    if (!targetPage) return;

    // Get height and set mobile nav height to page height
    let height = targetPage.clientHeight;
    elems.body.style.height = `${height}px`;

    // Hide active page
    let activePage = elems.pages.find(page => page.classList.contains("active"));
    if (activePage) activePage.classList.remove("active");

    // Set target as active
    targetPage.classList.add("active");
  }

  /* - Back */
  function BackToHome() {
    ShowPage("home");
  }

  /* Accordion List */
  function HideCategory(target) {
    target.classList.remove("active");
    target.nextElementSibling.style.maxHeight = "0";

    // Get height and set mobile nav height to page height
    let height = elems.pages.find(page => page.classList.contains("active")).clientHeight;
    elems.body.style.height = `${height - target.nextElementSibling.scrollHeight}px`;
  }

  function ShowCategory(target, extraHeight = 0) {
    target.classList.add("active");
    target.nextElementSibling.style.maxHeight = `${target.nextElementSibling.scrollHeight + extraHeight}px`;

    // Get height and set mobile nav height to page height
    let height = elems.pages.find(page => page.classList.contains("active")).clientHeight;
    elems.body.style.height = `${height + target.nextElementSibling.scrollHeight + extraHeight}px`;
  }

  function CategoryClickHandler(e = undefined) {
    if (e) e.preventDefault();

    // Toggle
    if (e.currentTarget.classList.contains("active")) {
      HideCategory(e.currentTarget);
    } else {
      ShowCategory(e.currentTarget);
    }
  }

  function HideSubcategory(target) {
    target.classList.remove("active");
    target.nextElementSibling.style.maxHeight = "0";

    // Get height and set mobile nav height to page height
    let height = elems.pages.find(page => page.classList.contains("active")).clientHeight;
    elems.body.style.height = `${height - target.nextElementSibling.scrollHeight}px`;
  }

  function ShowSubcategory(target) {
    target.classList.add("active");
    target.nextElementSibling.style.maxHeight = `${target.nextElementSibling.scrollHeight}px`;

    // Get height and set mobile nav height to page height
    let height = elems.pages.find(page => page.classList.contains("active")).clientHeight;
    elems.body.style.height = `${height + target.nextElementSibling.scrollHeight}px`;
  }

  function SubcategoryClickHandler(e = undefined) {
    if (e) e.preventDefault();

    let target = e.currentTarget;
    let targetParent = target.parentElement.parentElement.parentElement;

    // Toggle
    if (e.currentTarget.classList.contains("active")) {
      ShowCategory(targetParent.querySelector("a"), e.currentTarget.nextElementSibling.scrollHeight);
      HideSubcategory(e.currentTarget);
    } else {
      ShowCategory(targetParent.querySelector("a"), e.currentTarget.nextElementSibling.scrollHeight);
      ShowSubcategory(e.currentTarget);
    }
  }

  Init();

  return Object.freeze({
    Show,
    Hide,
  });
}

MobileNav = MobileNav();
